import { Grid } from '@mui/material';
import { Props } from '../../@types';

const ListContainer = ({ children }: Props) => {
    return (
        <Grid
            container
            sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                height: 'calc(100vh - 500px)',
                width: '100%',
            }}>
            {children}
        </Grid>
    )
}

export default ListContainer;